import {Brick, registerBrick, Service} from 'olympe';
import {combineLatest, of} from 'rxjs';

/**
 * This brick subscribe to the user services
 */
export default class SubscribeToUserService extends Brick {
    /**
     * @override
     */
    setupExecution($) {
        const frontendId = crypto.randomUUID();
        const userId = localStorage.getItem('Current_Sap_User');
        const userFullName = localStorage.getItem('userFullName');
        const [setUsersOutput] = this.getOutputs();
        const {observable} = Service.observe('userService', $,
            {userId: userId,
                userFullName: userFullName,
                frontendId: frontendId});

        observable.subscribe((data) => {
            const resultMap = new Map();

            for (const [prNumber, frontendIds] of data.frontendsCheckingAPR) {
                // For each PR, transform frontendIds into userInfos
                const userInfosWithDuplicates = frontendIds
                    .map((frontendId) => data.frontendIdUserLink.get(frontendId))
                    .filter(Boolean); // Remove undefined entries

                // Keep first occurrence of each userId while maintaining order
                const seenUserIds = new Set();
                const uniqueUserInfos = userInfosWithDuplicates.filter((userInfo) => {
                    if (seenUserIds.has(userInfo.userId)) {
                        return false; // Skip this duplicate
                    }
                    seenUserIds.add(userInfo.userId);
                    return true;
                });

                resultMap.set(prNumber, uniqueUserInfos);
            }

            $.set(setUsersOutput, resultMap);
        });

        return combineLatest([of(frontendId), ...this.getInputs().map((inputs) => $.observe(inputs))]);
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} frontendId
     * @param {string} userId
     * @param {string} userFullName
     * @param {string[]} openPrs
     * @param {function(Map<string, Set>)} setUsers
     */
    update($, [frontendId, openPrs], [setUsers]) {
        const oldOpenPrs = $.get('oldOpenPrs');

        if (!oldOpenPrs) { // First PR open
            $.set('oldOpenPrs', []);
            return;
        }

        let updatedPr;
        if (oldOpenPrs.length > openPrs.length) { // A PR has been added
            updatedPr = oldOpenPrs.find((pr) => !openPrs.includes(pr));
        } else if (oldOpenPrs.length < openPrs.length) { // A PR has been removed
            updatedPr = openPrs.find((pr) => !oldOpenPrs.includes(pr));
        } else { // No modification (when starting the brick)
            return;
        }
        $.set('oldOpenPrs', [...openPrs]);

        Service.publish('userService', ({frontendId: frontendId, openPrs: openPrs, updatedPr: updatedPr}))
            .catch((e) => {
                console.error(`Error while calling the service userService ${e}`);
            });
    }
}

registerBrick('018d5aee342790de220f', SubscribeToUserService);
